/**
 * @generated SignedSource<<fb3fb0fa76e6dfb09d96cc1b40cc5103>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
type AgentBadge_agent$fragmentType = any;
type AgentUpgradeBanner_agent$fragmentType = any;
import type { FragmentType } from "relay-runtime";
declare export opaque type JobEventAccepted_event$fragmentType: FragmentType;
export type JobEventAccepted_event$data = {|
  +actor: {|
    +node: ?{|
      +hostname?: ?string,
      +isDeprecated?: boolean,
      +operatingSystem?: ?{|
        +name: string,
      |},
      +version?: ?string,
      +versionHasKnownIssues?: boolean,
      +$fragmentSpreads: AgentBadge_agent$fragmentType & AgentUpgradeBanner_agent$fragmentType,
    |},
  |},
  +timestamp: any,
  +$fragmentType: JobEventAccepted_event$fragmentType,
|};
export type JobEventAccepted_event$key = {
  +$data?: JobEventAccepted_event$data,
  +$fragmentSpreads: JobEventAccepted_event$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobEventAccepted_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JobEventActor",
      "kind": "LinkedField",
      "name": "actor",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "AgentBadge_agent"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "AgentUpgradeBanner_agent"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hostname",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "version",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "versionHasKnownIssues",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isDeprecated",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "OperatingSystem",
                  "kind": "LinkedField",
                  "name": "operatingSystem",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "Agent",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "JobEvent",
  "abstractKey": "__isJobEvent"
};

(node/*: any*/).hash = "7a5afe0c18fb9948b31d6bc9cc203ed6";

module.exports = ((node/*: any*/)/*: Fragment<
  JobEventAccepted_event$fragmentType,
  JobEventAccepted_event$data,
>*/);
